import React, { useState } from "react";
import { createPortal } from "react-dom";
import "./CategoryManagerModal.css";

const DEFAULT_COLOR = "#3B82F6";

function CategoryManagerModal({
  isOpen,
  onClose,
  categories,
  onCreate,
  onUpdate,
  onDelete,
  isSaving,
  error,
}) {
  const [newName, setNewName] = useState("");
  const [newColor, setNewColor] = useState(DEFAULT_COLOR);

  if (!isOpen) return null;

  const handleCreate = async () => {
    const trimmed = newName.trim();
    if (!trimmed) return;
    await onCreate({ name: trimmed, color: newColor, shade_mini_calendar: false });
    setNewName("");
    setNewColor(DEFAULT_COLOR);
  };

  return createPortal(
    <div className="category-modal-overlay" onClick={onClose}>
      <div className="category-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Manage Categories</h3>
        <p className="category-modal-subtitle">Categories are private to your user profile.</p>

        {error ? <div className="category-modal-error">{error}</div> : null}

        <div className="category-list">
          {categories.map((category) => (
            <CategoryRow
              key={category.id}
              category={category}
              onUpdate={onUpdate}
              onDelete={onDelete}
              isSaving={isSaving}
            />
          ))}
        </div>

        <div className="category-add-section">
          <div className="category-add-row">
            <input
              className="cat-name-input"
              type="text"
              placeholder="New category name"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              disabled={isSaving}
            />
            <input
              className="cat-color-input"
              type="color"
              value={newColor}
              onChange={(e) => setNewColor(e.target.value)}
              disabled={isSaving}
              aria-label="New category color"
              title="Pick colour"
            />
            <button
              type="button"
              className="cat-btn cat-save-btn"
              title="Add category"
              onClick={handleCreate}
              disabled={isSaving || !newName.trim()}
            >
              ✓
            </button>
          </div>
        </div>

        <div className="category-modal-actions">
          <button type="button" onClick={onClose}>Done</button>
        </div>
      </div>
    </div>,
    document.body
  );
}

function CategoryRow({ category, onUpdate, onDelete, isSaving }) {
  const [name, setName] = useState(category.name || "");
  const [color, setColor] = useState(category.color || DEFAULT_COLOR);

  const changed =
    name.trim() !== (category.name || "") ||
    color !== (category.color || DEFAULT_COLOR);

  return (
    <div className="category-row">
      <input
        className="cat-name-input"
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        disabled={isSaving}
      />
      <input
        className="cat-color-input"
        type="color"
        value={color}
        onChange={(e) => setColor(e.target.value)}
        disabled={isSaving}
        aria-label={`Color for ${category.name}`}
        title="Pick colour"
      />
      <button
        type="button"
        className="cat-btn cat-save-btn"
        title="Save"
        onClick={() => onUpdate(category.id, { name: name.trim(), color, shade_mini_calendar: false })}
        disabled={isSaving || !name.trim() || !changed}
      >
        ✓
      </button>
      <button
        type="button"
        className="cat-btn cat-delete-btn"
        title="Delete"
        onClick={() => onDelete(category.id)}
        disabled={isSaving}
      >
        ✕
      </button>
    </div>
  );
}

export default CategoryManagerModal;
